// Step definitions for the first-run player tutorial.
//
// The tutorial lives entirely inside the player: it fires the first time the
// player is evoked (via "Play") and walks through the player controls a new
// user won't recognise. Each step points at a real element resolved by
// `selector`; the overlay re-measures as the layout settles. See
// TutorialOverlay.
//
// Start/Continue opens the dedicated reader on every viewport, so every step
// targets controls on that page and the walkthrough never changes routes.

export type TutorialPlacement = 'top' | 'bottom';

export interface TutorialStep {
  id: string;
  /** CSS selector for the element to spotlight. */
  selector: string;
  title: string;
  body: string;
  /** Where the callout sits relative to the spotlighted element. */
  placement?: TutorialPlacement;
}

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 'talk',
    selector: '[data-tutorial-id="player-speak"]',
    title: 'Talk to Aleph',
    body: 'Tap here at any time to speak with Aleph. Your audiobook will pause while you talk. You may be asked to allow access to your microphone. Wait for the beep, then speak. Ask a question, or just chat about what you are reading. The same control becomes "End conversation" while you talk — tap it to hang up.',
    placement: 'top',
  },
  {
    id: 'playpause',
    selector: '[data-tutorial-id="player-playpause"]',
    title: 'Play & pause',
    body: 'Play or pause the audiobook here. While you talk to Aleph, you can also just ask it to resume the reading for you.',
    placement: 'top',
  },
  {
    id: 'read-along',
    selector: '[data-tutorial-id="player-transcript"]',
    title: 'Read along',
    body: 'The reader shows the book text in sync with the narration. Tap any sentence to jump straight to that point in the audio.',
    placement: 'bottom',
  },
  {
    id: 'text-mode',
    selector: '[data-tutorial-id="player-text-toggle"]',
    title: 'Text mode',
    body: "Can't talk? Would rather text a question to Aleph? Tap here to switch to text mode and type your message instead. Tap again to get back to voice.",
    placement: 'top',
  },
];
